export default {
    viewBox: "0 0 25 24",
    paths: [
      "M19.2096 0.173077V3.98077H16.9452C15.1711 3.98077 14.8394 4.83173 14.8394 6.05769V8.78365H19.0654L18.5029 13.0529H14.8394V24H10.4259V13.0529H6.74805V8.78365H10.4259V5.63942C10.4259 1.99038 12.6615 0 15.9211 0C17.4788 0 18.8202 0.115385 19.2096 0.173077Z"
    ]
  };
